import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Paper, Typography } from '@mui/material';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import { DadosPedidoCardRow } from '../../utils/transcricaoDadosPedidoUtils';
import './revisaoSectionCard.css';

interface RevisaoSectionCardProps {
  rows: DadosPedidoCardRow[];
  onEditClick?: () => void;
}

const RevisaoSectionCard: React.FC<RevisaoSectionCardProps> = ({ rows, onEditClick }) => {
  const accessibility = useAccessibility();

  return (
    <Paper
      className="transcricao-revisao-section-card"
      elevation={0}
      style={accessibility.contrastBorderAccessibility}
    >
      {rows.map((row, rowIndex) => (
        <div
          key={`${row.fields.map((field) => field.label).join('-')}-${rowIndex}`}
          className={`transcricao-revisao-section-card-row${
            row.fields.length > 1 ? ' transcricao-revisao-section-card-row--split' : ''
          }`}
        >
          {row.fields.map((field) => (
            <div key={field.label} className="transcricao-revisao-section-card-field">
              <span
                className="transcricao-revisao-section-card-label"
                style={accessibility.textStyleAccessibility}
              >
                {field.label}
              </span>
              <span
                className="transcricao-revisao-section-card-value"
                style={accessibility.textStyleAccessibility}
              >
                {field.value ?? '—'}
              </span>
            </div>
          ))}
        </div>
      ))}

      {onEditClick && (
        <div className="transcricao-revisao-section-card-edit">
          <Button
            fullWidth
            variant="outlined"
            className="transcricao-revisao-section-card-edit-button"
            onClick={onEditClick}
            style={accessibility.contrastBorderAccessibility}
          >
            <FontAwesomeIcon icon={faEdit} aria-hidden />
            <Typography style={accessibility.textStyleAccessibility}>EDITAR</Typography>
          </Button>
        </div>
      )}
    </Paper>
  );
};

export default RevisaoSectionCard;
